<template>
<div class='b-page-wrapper b-page-wrapper--gray h-flex h-flex-center'>
    <FwPopup
        :centered='true'
        :isFixed='true'
        :max-width='isDesktop() ? "518px" : "calc(100% - 20px)"'
        width='90%'
        popupClass='b-popup-style--no-shadow'
        :allowBackgroundScrolling='true'
        :disableClosingOnClickOutside='true'
        popupBackground='#FAFAFC'
        popupRadius='20px'>
        <template #body>
            <div class='h-flex h-flex-space-between'>
                <ConfirmMyAccountForm
                    class='b-login-base-popup'
                    :globalServerError='globalServerError'
                    @submitForm='confirmMyAccount'>
                </ConfirmMyAccountForm>
            </div>
        </template>
    </FwPopup>
</div>
</template>

<script lang='ts'>
import { Component, mixins } from 'vue-facing-decorator';
import RedirectMixin from '@/mixins/redirect';
import AuthMixin from '@/mixins/auth';
import { AuthWebApi } from '@/api/auth/AuthApi';
import { ConfirmMyAccountForm } from '@/components/forms/auth/ConfirmMyAccountForm';
import { LogInForm } from '@/components/forms/auth/LogInForm';
import { SignUpPayloadType } from '@/types/Auth';
import i18n from '@/locale';
import { useUserStore } from '@/stores/useUserStore';

const GLOBAL_AUTH_ERROR: string = i18n.global.t('ERRORS.LOGIN.PASSWORD');

@Component({
    components: {
        ConfirmMyAccountForm,
        LogInForm,
    },
})
export default class ConfirmMyAccount extends mixins(RedirectMixin, AuthMixin) {
    userStore = useUserStore();
    globalServerError: string = '';

    async confirmMyAccount(payload: SignUpPayloadType) {
        try {
            const { data } = await AuthWebApi.signUp(payload);
            this.userStore.CONFIRM_USER_DATA(data.user);
            this.doLoginUser(data.user);
            this.$router.push({ name: 'CreatePassword' });
        } catch (err) {
            this.globalServerError = GLOBAL_AUTH_ERROR;
        }
    }
}
</script>

<style lang='sass'>
.b-login-base-popup
    width: 418px
    background-color: #fff
    border-radius: 10px
    padding: 40px 51px
    box-shadow: -10px 0 49px 0 rgba(32,63,106,0.03)
</style>
